import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/**
 * wms veb-marshrutlari.
 *  W: /w/wms/* — modul layout (gorizontal sub-nav) ichida bo'limlar.
 *  S: /s/stock, /s/supplies — hamkor qoldiqlari va yetkazmalari.
 *
 * SKAN ISH O'RINLARI VEBDA YO'Q (Stocker qarori): «Buyurtma yig'ish» (Сборка заказов) va
 * «Topshirish» (Выдача) faqat `apps/app-w` ilovasida — paketlar ombor ichida yig'iladi va
 * topshiriladi, u yerda kompyuter yo'q. Vebda ularning NATIJASI ko'rinadi (`parcels`,
 * partiya tafsiloti). Istisno — «Ombordan qabul» (`handover`): menejer kompyuterga apparat
 * skaner ulab ishlaydi, shuning uchun u veb bo'limi bo'lib qoladi.
 */
export const workRoutes: RouteObject[] = [
  {
    path: 'wms',
    ...page(() => import('./components/WmsLayout')),
    children: [
      { index: true, ...page(() => import('./pages/OverviewPage')) },
      { path: 'stock', ...page(() => import('./pages/StockPage')) },
      { path: 'supplies', ...page(() => import('./pages/SuppliesPage')) },
      { path: 'supplies/:id', ...page(() => import('./pages/SupplyDetailPage')) },
      { path: 'batches', ...page(() => import('./pages/BatchesPage')) },
      { path: 'batches/:id', ...page(() => import('./pages/BatchDetailPage')) },
      { path: 'parcels', ...page(() => import('./pages/ParcelsPage')) },
      { path: 'handover', ...page(() => import('./pages/HandoverPage')) },
      { path: 'returns', ...page(() => import('./pages/ReturnsPage')) },
      { path: 'invoices', ...page(() => import('./pages/InvoicesPage')) },
      { path: 'cancel-requests', ...page(() => import('./pages/CancelRequestsPage')) },
      { path: 'inventory', ...page(() => import('./pages/InventoryPage')) },
      { path: 'inventory/:id', ...page(() => import('./pages/InventoryDetailPage')) },
      { path: 'movements', ...page(() => import('./pages/MovementsPage')) },
      { path: 'structure', ...page(() => import('./pages/StructurePage')) },
      { path: 'materials', ...page(() => import('./pages/MaterialsPage')) },
      { path: 'volume', ...page(() => import('./pages/VolumePage')) },
      { path: 'stations', ...page(() => import('./pages/StationsPage')) },
      { path: 'pick-groups', ...page(() => import('./pages/PickGroupsPage')) },
    ],
  },
];

export const sellerRoutes: RouteObject[] = [
  { path: 'stock', ...page(() => import('./pages/SellerStockPage')) },
  { path: 'supplies', ...page(() => import('./pages/SellerSuppliesPage')) },
  { path: 'supplies/:id', ...page(() => import('./pages/SupplyDetailPage')) },
];
